import { Injectable } from "@angular/core";

@Injectable()
export class CartService {
  itemCart: any = {};
  produtos = [];

  constructor() {
    this.produtos;
  }

  OnsaveLS(item: any) {
    let NovosProdutos = JSON.parse(localStorage.getItem("NovosProdutos"));
    if (NovosProdutos == null) {
      NovosProdutos = [];
    }
    let totalPrecoComplemento: number = 0;
    let totalPreco: number = 0;
    for (let k = 0; k <= item.complementos.length - 1; k++) {
      totalPrecoComplemento = totalPrecoComplemento + Number(item.complementos[k].Com_Preco);
    }
    totalPreco = totalPrecoComplemento + Number(item.vlrUnitario);
    this.itemCart = item;
    this.itemCart.vlrTotalItem = totalPreco * item.quantidade;
    this.itemCart.vlrTotalComplementos = totalPrecoComplemento
    NovosProdutos.push(this.itemCart);
    localStorage.setItem("NovosProdutos", JSON.stringify(NovosProdutos));
  }

  filterItems(searchTerm) {
    return this.produtos.filter((item) => {
      return item.Prod_Nome.toLowerCase().includes(searchTerm.toLowerCase());
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/cart.service.ts